package org.braunequip.web.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.*
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

data class UserAlert @OptIn(ExperimentalUuidApi::class) constructor(
    val id: String = Uuid.random().toString(),
    val message: String,
    val color: CSSColorValue,
    val borderColor: CSSColorValue,
    val durationMillis: Int = 3000
)

class AlertManager {
    private val _alerts = mutableStateListOf<UserAlert>()
    val alerts: List<UserAlert> get() = _alerts

    fun addAlert(alert: UserAlert) {
        _alerts.add(alert)
    }

    fun removeAlert(alert: UserAlert) {
        _alerts.remove(alert)
    }

    @Composable
    fun DisplayAlerts() {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .position(Position.Absolute)
                .zIndex(99)
                .top(54.px)
                .gap(6.px)
                .pointerEvents(PointerEvents.None),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            for (alert in alerts.toList()) {
                DisplayAlert(alert = alert) {
                    removeAlert(alert)
                }
            }
        }
    }
}

@Composable
fun DisplayAlert(
    alert: UserAlert,
    onDismiss: () -> Unit
) {
    var visible by remember { mutableStateOf(true) }
    var dismissed by remember { mutableStateOf(false) }

    val animationModifier = Modifier
        .transition(
            Transition.all(250.ms, timingFunction = TransitionTimingFunction.EaseInOut)
        )
        .opacity(if (dismissed) 0 else 1)
        .transform {
            translateY(
                if (dismissed) (0).px else (-20).px
            )
        }

    LaunchedEffect(Unit) {
        delay(alert.durationMillis.toLong())
        dismissed = true
        delay(250) // Let the animation finish
        visible = false
        onDismiss()
    }

    if (visible) {
        Row(
            modifier = Modifier
                .width(450.px)
                .maxWidth(450.px)
//                        .height(50.px)
                .border(2.px, LineStyle.Solid, alert.borderColor)
                .borderRadius(5.px)
                .backgroundColor(alert.color)
                .padding(leftRight = 16.px, topBottom = 12.px)
                .then(animationModifier),
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(alert.message, Modifier.color(Colors.White).fontFamily(FONT_FAMILY).textAlign(TextAlign.Center))
        }
    }
}